import { render, staticRenderFns } from "./stuInfo.vue?vue&type=template&id=abfc7a42&scoped=true&"
import script from "./stuInfo.vue?vue&type=script&lang=js&"
export * from "./stuInfo.vue?vue&type=script&lang=js&"
import style0 from "./stuInfo.vue?vue&type=style&index=0&id=abfc7a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfc7a42",
  null
  
)

export default component.exports